import * as React from 'react';
import * as styles from './PeopleFinderHeader.css';
import { inject, observer } from 'mobx-react';
import { IAPersonaImage } from '../../personaImage/PersonaImage';
import { PeopleFinderStore } from '../stores/PeopleFinderStore';
import { IAIcon } from '../../icon/Icon';
import { Environment } from '../../../services/Environment';
import { Helper } from '../../../Helper';
import { LocalizationService } from '../../../services/LocalizationService';

export interface IPeopleFinderHeaderProps {
  peopleFinderStore?: PeopleFinderStore;
  Close: () => void;
}

@inject('peopleFinderStore')
@observer
export class PeopleFinderHeader extends React.Component<IPeopleFinderHeaderProps> {
  private headerSkeleton = () => (
    <div className={styles.IA_peopleFinder_header}>
      <div className={styles.IA_peopleFinder_header_personaWrapper}>
        <div className={styles.IA_peopleFinder_header_profileImageWrapper}>
          <IAPersonaImage name={''} size={68} showSkeleton={true} />
        </div>
        <div className={styles.IA_peopleFinder_header_profileInfoContainer}>
          <div className={styles.IA_peopleFinder_header_profileNameSkeleton} />
          <div className={styles.IA_peopleFinder_header_profileDateAndLocationSkeleton} />
        </div>
        {this.props.peopleFinderStore.type === 'navigator' && (
          <div className={styles.IA_peopleFinder_header_closeIcon} onClick={() => this.props.Close()}>
            <IAIcon title="Close" size={16} color={this.props.peopleFinderStore.design.colors.iconColor} />
          </div>
        )}
      </div>
      <div className={styles.IA_peopleFinder_header_topItemsWrapper}>
        <div className={styles.IA_peopleFinder_header_topItemStartSpace}></div>
        <div className={styles.IA_peopleFinder_header_topItem}>
          <div className={styles.IA_peopleFinder_header_TopItemSkeleton} />
        </div>
      </div>
    </div>
  );
  public render() {
    const date = new Date();
    const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    const dayNumber = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date);
    const monthName = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
    const dayName = new Intl.DateTimeFormat('en', { weekday: 'long' }).format(date);
    const time = date.toTimeString().substring(0, 5);
    const displayedDate = `${dayName} ${dayNumber} ${monthName}. ${year} ${time}`;
    return (
      <React.Fragment>
        {this.props.peopleFinderStore.isFetchingProfile && this.headerSkeleton()}
        {!this.props.peopleFinderStore.isFetchingProfile && (
          <div className={styles.IA_peopleFinder_header}>
            <div className={styles.IA_peopleFinder_header_personaWrapper}>
              <div className={styles.IA_peopleFinder_header_profileImageWrapper}>
                <IAPersonaImage
                  name={this.props.peopleFinderStore.profile?.displayName}
                  backgroundColor={this.props.peopleFinderStore.design.colors.mainColor}
                  fontSize={35}
                  profileImage={Helper.getProfileImageUrlFromImageAPI(
                    Environment.getEnvironmentForImageAPI(this.props.peopleFinderStore.environment),
                    this.props.peopleFinderStore.tenantName,
                    this.props.peopleFinderStore.token,
                    this.props.peopleFinderStore.profile?.email
                  )}
                  size={68}
                  showSkeleton={this.props.peopleFinderStore.isFetchingProfile}
                />
              </div>
              <div className={styles.IA_peopleFinder_header_profileInfoContainer}>
                <div className={styles.IA_peopleFinder_header_profileName}>
                  Hello, {this.props.peopleFinderStore.profile?.displayName}
                </div>
                <div className={styles.IA_peopleFinder_header_profileDateAndLocation}>{displayedDate}, Copenhagen</div>
              </div>
              {this.props.peopleFinderStore.type === 'navigator' && (
                <div className={styles.IA_peopleFinder_header_closeIcon} onClick={() => this.props.Close()}>
                  <IAIcon title="Close" size={16} color={this.props.peopleFinderStore.design.colors.iconColor} />
                </div>
              )}
            </div>
            <div className={styles.IA_peopleFinder_header_topItemsWrapper}>
              <div className={styles.IA_peopleFinder_header_topItemStartSpace}></div>
              <div className={styles.IA_peopleFinder_header_topItem}>
                {new LocalizationService().strings.PeopleFinder_Colleagues?.toUpperCase()}
                <div className={styles.IA_peopleFinder_header_topItemActiveLine} style={{ borderColor: this.props.peopleFinderStore.design.colors.highlightColor }}></div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
